(function ($) {
  /*
   * Check for non display:none visibility. It's common to have other types of
   * hiding like opacity, height:0; overflow:hiden, etc. 
   *
   * We have to check the parents for cases that would negatve the elements
   * visbility and more specifically it's abilit to receive events.
   */
  var element_is_visible = function (el) {
    var $parents = $(el).parents();
    var visible = true;

    $parents.each(function (i, obj) {
      $parent = $(obj);
      if ($parent.css('overflow') == 'hidden') {
        if ($parent.height() == 0 || $parent.width() == 0) {
          visible = false;

          return false;
        }
      }
    });

    return visible;
  };
  var _create_template_id_data_key = function (template_id) {
    return '[data-range-template-id="' + template_id + '"]';
  };
  var _create_filter_key_data_key = function (filter_key) {
    return '[data-shade-filter-' + filter_key + ']';
  };

  function ShadeFinderWidgetManager($template) {
    this.init($template);
  }

  ShadeFinderWidgetManager.prototype.init = function ($template) {
    this.touch_sliding = false;

    this.$template = $template;
    this._init_vars();
    this._init_handlers();
  };

  ShadeFinderWidgetManager.prototype._init_vars = function () {
  };

  ShadeFinderWidgetManager.prototype._init_handlers = function () {
    this.unhandled_touchstart = false;
    this.touch_sliding = false;
    this.isMouseDown = false;

    this._init_mouse_detect();

    var that = this;
    var $template = this.$template;

    $(document).on('touchstart', function (e) {
      that.unhandled_touchstart = true;
    });

    $(document).on('touchend', function (e) {
      that.touchend_handler(e);
    });
  };

  ShadeFinderWidgetManager.prototype._init_mouse_detect = function () {
    var $template = this.$template;
    var self = this;

    $template.on('mousedown', function (e) {
      if (e.type == 'mousedown' && e.button != 0) {
        return;
      }
      self.isMouseDown = true;
    });

    $template.on('mouseup', function (e) {
      if (self.isMouseDown && !self.touch_sliding) {
        console.log('mouseup');
      }
      self.isMouseDown = false;
    });
  };

  ShadeFinderWidgetManager.prototype.touchend_handler = function (e) {
    // only do somethign if the touch start event was unhandled. we detect this
    // in another handler
    if (!this.unhandled_touchstart) {
      return;
    }
    var $template = this.$template;

    // Only run for visibile elemnts
    if (!element_is_visible($slider)) {
      return;
    }

    console.log(e);
    var pageX = e.pageX ? e.pageX : e.originalEvent.changedTouches[0].pageX;
    var pageY = e.pageY ? e.pageY : e.originalEvent.changedTouches[0].pageY;
  };

  Drupal.behaviors.shadeFinderBlockWidget = {
    attach: function (context, settings) {
      // This was removed for launch. But pushing up WIP.
      return;
      var template_name = 'shade_finder_block_widget_v1';
      var $formatters = $('.js-range-slider-carousel__widget', context);

      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var rerender_template = $formatter.data('rerender-template-name');

        // only apply to widget section using this template
        if (rerender_template != template_name) {
          return;
        }

        var manager = new ShadeFinderWidgetManager($formatter);

        console.log($formatter);
      });
    }
  };
})(jQuery);
